<template>
  <div class="utilities_page" style="height: 100%">
    <div class="status_list">
      <UtilitiesItem
        v-for="(utility, key) in utilities_list"
        :key="key"
        :utility="utility"
        class="setting-item"
      />
    </div>
  </div>
</template>

<script>
import UtilitiesItem from './Utilities/UtilitiesItem'
export default {
  name: 'Utilities',
  components: {
    UtilitiesItem
  },
  data () {
    return {
      utilities_list: {}
    }
  },
  mounted () {
    this.$http.v1.getUtilities((response) => {
      this.utilities_list = response.data
    })
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
  .utilities_page_page{
    padding: 10px;
  }
  .card_add{
    margin-bottom: 15px;
  }
  .status_list{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    .setting-item{
      width: 25%;
      padding: 10px;
    }
  }

  @media (max-width: 1440px) {
    .status_list{
      .setting-item{
        width: 33%;
      }
    }
  }

  @media (max-width: 768px) {
    .status_list{
      .setting-item{
        width: 50%;
      }
    }
  }

  @media (max-width: 500px) {
    .status_list{
      .setting-item{
        width: 100%;
      }
    }
  }
</style>
